
import React from 'react';

import Dashboard from './dashboard';
import styled from 'styled-components';
import {BrowserRouter as Router,Route,Switch,withRouter} from 'react-router-dom';
import Link from './../components/elements/link';
import Login from './login';
const Main: React.FC = () => <>
  <Link to="home">Home</Link>
  <Link to="house">House</Link>
  <Link to="pent">Pent Home</Link>
</>

const Container: React.FC = (props: any) => {

  return (
    <Wrapper className="main-frame">
      <Switch>
        <Route path="/login" component={Login} exact/>
        <Route path="/" component={Dashboard}/>
      </Switch>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }

  div.transition-group {
    position: relative;
  }

  section.route-section {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
`; 
export default withRouter(Container);